<script lang="ts">
	// Yeah; this type is weird.
	// I built it from what the server actually sends though.
	type ServerErrorResponse = {
		errors: {
			message: string
			stack?: any
		}[]
		message: string
	}

	// This is very similar to /cf_workers/www/barnacle/src/ErrorMessage.svelte, but this is for Ops
	export let message = ``
	export let server_error_response: unknown | null = null

	function is_object(e: unknown): e is (ServerErrorResponse | Error | object) {
		return e !== null && typeof e === `object`
	}

	function is_server_error_response(e: (ServerErrorResponse | Error | object)): e is ServerErrorResponse {
		return Object.hasOwn(e, `errors`) && Array.isArray((e as ServerErrorResponse).errors)
	}
</script>

{#if is_object(server_error_response)}
	{#if is_server_error_response(server_error_response)}
		{#each server_error_response.errors as error}
			{#if error.message}
				<p>{error.message}</p>
				{#if error.stack}
					<pre>{error.stack}</pre>
				{/if}
			{:else}
				<pre>{JSON.stringify(error)}</pre>
			{/if}
		{/each}
	{:else if server_error_response instanceof Error}
		<p>{server_error_response.message}</p>
	{:else}
		<pre>{JSON.stringify(server_error_response)}</pre>
	{/if}
{:else}
	<p>{message}</p>
{/if}

<style>
	p, pre {
		color: var(--attention-red);
	}
</style>
